/*
*###############################################################################
*Module Name                   : VoucherBarcodePrintContent.js                   #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  W M Shanika Chamodi                          #
*Date                          : Thursday, January 12th 2022, 9:51:53 am        #
*Copyright © 2022 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState } from "react"
import {
  CardText,
  Col,
  Row,
  Alert,
  Button,
} from "reactstrap"
//Import Framework components
import DPTextBox from "framework/components/DPTextBox"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import { loadPopupSearchPay } from "../../../framework/validators/SearchColumn"
const VoucherBarcodePrintContent = ({
  AlertColor,
  AlertMsg,
  show,
  Gen_VoucherFrom,
  Gen_VoucherFrom_OnChange,
  Gen_VoucherFrom_Enabled,
  Gen_VoucherFromSearch,
  Gen_VoucherTo,
  Gen_VoucherTo_OnChange,
  Gen_VoucherTo_Enabled,
  Gen_VoucherToSearch,
  Gen_BookFrom,
  Gen_BookFrom_OnChange,
  Gen_BookFrom_Enabled,
  Gen_BookFromSearch,
  Gen_BookTo,
  Gen_BookTo_OnChange,
  Gen_BookTo_Enabled,
  Gen_BookToSearch,
  Gen_GRNNo,
  Gen_GRNNo_OnChange,
  Gen_GRNNo_Enabled,
  Gen_GRNNoSearch,

  SearchDefaultSortedVouFrom,
  SearchModelOpenVouFrom,
  SearchModelTriggerVouFrom,
  SearchGetSelectRowVouFrom,

  SearchDefaultSortedVouTo,
  SearchModelOpenVouTo,
  SearchModelTriggerVouTo,
  SearchGetSelectRowVouTo,

  SearchDefaultSortedBookFrom,
  SearchModelOpenBookFrom,
  SearchModelTriggerBookFrom,
  SearchGetSelectRowBookFrom,

  SearchDefaultSortedBookTo,
  SearchModelOpenBookTo,
  SearchModelTriggerBookTo,
  SearchGetSelectRowBookTo,

  SearchDefaultSortedGRN,
  SearchModelOpenGRN,
  SearchModelTriggerGRN,
  SearchGetSelectRowGRN,
  Gen_LoadVouchersSearch,
  menuCode,
}) => {

  const [grnSearchCol, setgrnSearchCol] = useState([])
  const [BookNoFromSearchCol, setBookNoFromSearchCol] = useState([])
  const [BookNoToSearchCol, setBookNoToSearchCol] = useState([])
  const [VoucherNoFromSearchCol, setVoucherNoFromSearchCol] = useState([])
  const [VoucherNoToSearchCol, setVoucherNoToSearchCol] = useState([])

  const [Datatablesub, SetDatatablesub] = useState([])
  const [groupFilter, SetGroupFilter] = useState('a')
  //*** End of useStates */
  const ApiURL = window.Links.ApiURL


  React.useEffect(async () => {

    setgrnSearchCol(await loadPopupSearchPay(menuCode, "VOUPGRN"))
    setBookNoFromSearchCol(await loadPopupSearchPay(menuCode, "VOUPBF"))
    setBookNoToSearchCol(await loadPopupSearchPay(menuCode, "VOUPBT"))
    setVoucherNoFromSearchCol(await loadPopupSearchPay(menuCode, "VOUPNF"))
    setVoucherNoToSearchCol(await loadPopupSearchPay(menuCode, "VOUPNT"))

  }, [menuCode])



  return (
    <React.Fragment>
      <div>
        <Col sm="12">
          <CardText className="mb-0">
            <Row>
              {show ? (
                <Alert color={AlertColor} role="alert">
                  {AlertMsg}
                </Alert>
              ) : null}
              <Col sm={12} md={6} className="mb-4-sm">


                <Row>
                  <Col>
                    <DPTextBox
                      rowClass="mb-2-sm"
                      labelText="Voucher From"
                      textType="text"
                      maxLength="50"
                      value={Gen_VoucherFrom}
                      onChange={Gen_VoucherFrom_OnChange}
                      disabled={Gen_VoucherFrom_Enabled}
                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm">
                    <Button
                      onClick={Gen_VoucherFromSearch}
                      color="success"
                      className="btn-sm"
                    >
                      <i
                        className="mdi mdi-search-web"
                        style={{ fontSize: "12px" }}
                      ></i>
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <DPTextBox
                      rowClass="mb-2-sm"
                      labelText="Book No From"
                      textType="text"
                      maxLength="50"
                      value={Gen_BookFrom}
                      onChange={Gen_BookFrom_OnChange}
                      disabled={Gen_BookFrom_Enabled}
                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm">
                    <Button
                      onClick={Gen_BookFromSearch}
                      color="success"
                      className="btn-sm"
                    >
                      <i
                        className="mdi mdi-search-web"
                        style={{ fontSize: "12px" }}
                      ></i>
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col>

                    <DPTextBox
                      rowClass="mb-2-sm"
                      labelText="GRN No"
                      textType="text"
                      maxLength="50"
                      value={Gen_GRNNo}
                      onChange={Gen_GRNNo_OnChange}
                      disabled={Gen_GRNNo_Enabled}
                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm">
                    <Button
                      onClick={Gen_GRNNoSearch}
                      color="success"
                      className="btn-sm"
                    >
                      <i
                        className="mdi mdi-search-web"
                        style={{ fontSize: "12px" }}
                      ></i>
                    </Button>
                  </Col>

                </Row>
              </Col>
              <Col sm={12} md={6} className="mb-4-sm">

                <Row>
                  <Col>
                    <DPTextBox
                      rowClass="mb-2-sm"
                      labelText="Voucher To"
                      textType="text"
                      maxLength="50"
                      value={Gen_VoucherTo}
                      onChange={Gen_VoucherTo_OnChange}
                      disabled={Gen_VoucherTo_Enabled}
                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm">
                    <Button
                      onClick={Gen_VoucherToSearch}
                      color="success"
                      className="btn-sm"
                    >
                      <i
                        className="mdi mdi-search-web"
                        style={{ fontSize: "12px" }}
                      ></i>
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <DPTextBox
                      rowClass="mb-2-sm"
                      labelText="Book No To"
                      textType="text"
                      maxLength="50"
                      value={Gen_BookTo}
                      onChange={Gen_BookTo_OnChange}
                      disabled={Gen_BookTo_Enabled}
                    /> </Col>
                  <Col sm={12} md={1} className="mb-4-sm">
                    <Button
                      onClick={Gen_BookToSearch}
                      color="success"
                      className="btn-sm"
                    >
                      <i
                        className="mdi mdi-search-web"
                        style={{ fontSize: "12px" }}
                      ></i>
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12} md={3} className="mb-4-sm"> </Col>
                  <Col sm={12} md={3} className="mb-4-sm">
                    <Button
                      onClick={Gen_LoadVouchersSearch}
                      color="success"
                      className="btn-sm"
                    >
                      Load Vouchers
                    </Button></Col> </Row>
              </Col>
            </Row>

            <Row>
              <Col sm={12} md={6} className="mb-3-sm"></Col>
              <Col sm={12} md={6} className="mb-3-sm"></Col>
            </Row>
          </CardText>
        </Col>

        {/* <DPSearchBox
          searchData={SearchDataTablesVouFrom}
          columns={SearchColumnsVouFrom}
          defaultSorted={SearchDefaultSortedVouFrom}
          mainTitle="Voucher Number Search"
          SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={SearchModelOpenVouFrom}
          toggle={SearchModelTriggerVouFrom}
          getSelect={SearchGetSelectRowVouFrom}
        /> */}


        <DPSearchBoxDynamic
          searchData={Datatablesub}
          columns={VoucherNoFromSearchCol}
          defaultSorted={SearchDefaultSortedVouFrom}
          mainTitle={"Voucher Number Search"}
          SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={SearchModelOpenVouFrom}
          toggle={SearchModelTriggerVouFrom}
          getSelect={SearchGetSelectRowVouFrom}
          APIURL={ApiURL}
          URLPath={"VOUPNF"}
          MenuCode={menuCode}
          KeyVal={'VNO'}
          searchBy={'VC_NUMBER'}
          FilterStr={groupFilter}
        />



        {/* <DPSearchBox
          searchData={SearchDataTablesVouTo}
          columns={SearchColumnsVouTo}
          defaultSorted={SearchDefaultSortedVouTo}
          mainTitle="Voucher Number Search"
          SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={SearchModelOpenVouTo}
          toggle={SearchModelTriggerVouTo}
          getSelect={SearchGetSelectRowVouTo}
        /> */}


        <DPSearchBoxDynamic
          searchData={Datatablesub}
          columns={VoucherNoToSearchCol}
          defaultSorted={SearchDefaultSortedVouTo}
          mainTitle={"Voucher Number Search"}
          SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={SearchModelOpenVouTo}
          toggle={SearchModelTriggerVouTo}
          getSelect={SearchGetSelectRowVouTo}
          APIURL={ApiURL}
          URLPath={"VOUPNT"}
          MenuCode={menuCode}
          KeyVal={'VNO'}
          searchBy={'VC_NUMBER'}
          FilterStr={groupFilter}
        />



        {/* <DPSearchBox
          searchData={SearchDataTablesBookFrom}
          columns={SearchColumnsBookFrom}
          defaultSorted={SearchDefaultSortedBookFrom}
          mainTitle="Book Number Search"
          SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={SearchModelOpenBookFrom}
          toggle={SearchModelTriggerBookFrom}
          getSelect={SearchGetSelectRowBookFrom}
        /> */}


        <DPSearchBoxDynamic
          searchData={Datatablesub}
          columns={BookNoFromSearchCol}
          defaultSorted={SearchDefaultSortedBookFrom}
          mainTitle={"Book Number Search"}
          SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={SearchModelOpenBookFrom}
          toggle={SearchModelTriggerBookFrom}
          getSelect={SearchGetSelectRowBookFrom}
          APIURL={ApiURL}
          URLPath={"VOUPBF"}
          MenuCode={menuCode}
          KeyVal={'BNO'}
          searchBy={'VC_BOOKNO'}
          FilterStr={groupFilter}
        />


        {/* <DPSearchBox
          searchData={SearchDataTablesBookTo}
          columns={SearchColumnsBookTo}
          defaultSorted={SearchDefaultSortedBookTo}
          mainTitle="Book Number Search"
          SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={SearchModelOpenBookTo}
          toggle={SearchModelTriggerBookTo}
          getSelect={SearchGetSelectRowBookTo}
        /> */}


        <DPSearchBoxDynamic
          searchData={Datatablesub}
          columns={BookNoToSearchCol}
          defaultSorted={SearchDefaultSortedBookTo}
          mainTitle={"Book Number Search"}
          SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={SearchModelOpenBookTo}
          toggle={SearchModelTriggerBookTo}
          getSelect={SearchGetSelectRowBookTo}
          APIURL={ApiURL}
          URLPath={"VOUPBT"}
          MenuCode={menuCode}
          KeyVal={'BNO'}
          searchBy={'VC_BOOKNO'}
          FilterStr={groupFilter}
        />


        {/* <DPSearchBox
          searchData={SearchDataTablesGRN}
          columns={SearchColumnsGRN}
          defaultSorted={SearchDefaultSortedGRN}
          mainTitle="Voucher Good Received Note Search"
          SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={SearchModelOpenGRN}
          toggle={SearchModelTriggerGRN}
          getSelect={SearchGetSelectRowGRN}
        /> */}


        <DPSearchBoxDynamic
          searchData={Datatablesub}
          columns={grnSearchCol}
          defaultSorted={SearchDefaultSortedGRN}
          mainTitle={"Voucher Good Received Note Search"}
          SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={SearchModelOpenGRN}
          toggle={SearchModelTriggerGRN}
          getSelect={SearchGetSelectRowGRN}
          APIURL={ApiURL}
          URLPath={"VOUPGRN"}
          MenuCode={menuCode}
          KeyVal={'VNO'}
          searchBy={'HED_RUNNO'}
          FilterStr={groupFilter}
        />

      </div>
    </React.Fragment>
  )
}
export default VoucherBarcodePrintContent
